if (process.env.NODE_ENV === 'production') {
  const scriptEl = document.querySelector('script[src*="main."]') as HTMLScriptElement;
  const scriptPath = scriptEl.src;
  const baseURL = scriptPath.substring(0, scriptPath.lastIndexOf('/'));
  // @ts-ignore
  __webpack_public_path__ = `${baseURL}/`;
}
